<template>
<li class="FirstLayer" :class='{"Bulletpoint": itemValues.bulletPoint, "Pagebreak": itemValues.pageBreak}'>
	<span>{{itemValues.name}}</span>
	<span>{{itemValues.price}}</span>
	<span>{{itemValues.time}}</span>
	<ul>
		<slot>

		</slot>
	</ul>
</li>
</template>

<script>
export default {
	name: 'FirstLayer',
	props: {
		itemValues: {
			type: Object,
			default () {
				return {
					name: "",
					time: "",
					price: "",
					timeInDays: false,
				}
			}
		},

	},
	components: {},
	data() {
		return {}
	},
	created() {

	},

	watch: {

	},
	computed: {

	},
	methods: {

	},

	mounted() {

	}
}
</script>

<style scoped lang="scss">
.FirstLayer {
	padding-left: 40px;
	position: relative;
	display: block;
	margin-top: 3pt;

	&.Bulletpoint {
		&::before {
			content: "";
			position: absolute;
			width: 3px;
			height: 3px;
			background-color: #000;
			border-radius: 100%;
			top: 6pt;
			left: 25px;
		}
	}

	&:not(.Bulletpoint) {
		margin-top: calc(3pt + 30px);
		padding-left: 15px;

        &:first-child {
            margin-top: 30px;
        }

		> span:first-child {
			line-height: 1.5em;
		}
	}

	.Phase--noName & {
		display: none;

		&.Pagebreak {
			display: block;

			& ~ li {
				display: block;
			}
		}
	}

	.Phase--optional & {
		padding-left: 0;

		&.Bulletpoint {
			padding-left: 25px;

			&::before {
				left: 10px;
			}
		}
	}

	&.Pagebreak {
		display: none;

		& ~ li {
			display: none;
		}
	}

	ul {
		max-width: 100%;
		margin-top: 3pt;
	}
}
</style>



// WEBPACK FOOTER //
// FirstLayer.vue?50c792e0